import styled from "styled-components";

import { Caption, Flex } from "@olist/design-system";
import { DataTable } from "@olist/templates";

export const SupportTicketsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  table tr td:last-child {
    display: flex;
    justify-content: flex-end;
  }
  height: 100%;
  min-height: 70vh;
  row-gap: 16px;
`;

export const CustomDataTableHeader = styled(DataTable.TableHeader)`
  display: flex;
  justify-content: flex-end;
`;

export const TruncatedText = styled(Flex)`
  flex-shrink: 1;
  font-size: 14px;
  font-weight: 700;
`;

export const PageDescription = styled(Caption)`
  color: ${({ theme }) => theme.olist.color.neutral.base};
  font-size: 16px;
  margin-bottom: ${({ theme }) => theme.olist.spacing.stack.medium};
  text-align: justify;
`;

export const TicketDescription = styled(Caption)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
`;
